module.exports = __webpack_public_path__ + "static/media/gel8.6b86ba41.svg";